// extracted by mini-css-extract-plugin
export var backgroundColor = "ContentCards1-module--background-color--d1627";